import { MemberMap } from '@nextforce/api'
import { Reader } from '../../types'
import * as Response from './response'

export function convertReadReceipt(
  readReceipt: Response.ReadReceipt,
  memberMap: MemberMap
): Reader | undefined {
  const member = memberMap[String(readReceipt.reader_id)]

  if (member) {
    return {
      member,
      timestamp: parseInt(readReceipt.timestamp),
    }
  }
}
